import { type z } from 'zod'

import { schemas } from '~interface/zod-schema'

// Values
export const ProcessVerification = schemas.ProcessVerificationEnum
export const TagAutomationAction = schemas.TagAutomationActionEnum
export const TagAutomationTarget = schemas.TagAutomationTargetEnum

// Types
export type DemoBlock = z.infer<typeof schemas.DemoBlock>
export type APIAutomation = z.infer<typeof schemas.APIAutomation>
export type APIEndpointId = z.infer<typeof schemas.APIEndpointIdField>
export type ReviewBlock = z.infer<typeof schemas.ReviewBlock>
export type ReviewOutcome = z.infer<typeof schemas.AcceptEnum>
export type ReviewFocusField = z.infer<typeof schemas.ReviewFocusField>
export type ReviewFocusFieldInput = z.infer<typeof schemas.ReviewFocusFieldInput>
export type ReviewerRulesetInput = z.infer<typeof schemas.ReviewerRulesetInput>
export type EditReviewBlockViewRequestData = z.infer<typeof schemas.EditReviewBlockViewRequestData>
export type WorkspaceGroup = z.infer<typeof schemas.Group>
export type WorkspaceUser = z.infer<typeof schemas.WorkspaceUser>
export type EnsuredSingletonGroups = z.infer<typeof schemas.EnsureSingletonGroupsViewResponseData>
export type Block = z.infer<typeof schemas.Block>
export type BlockId = z.infer<typeof schemas.BlockIdField>
export type BlockInstanceId = z.infer<typeof schemas.BlockInstanceIdField>
export type Connector = z.infer<typeof schemas.Connector>
export type ConnectorId = z.infer<typeof schemas.ConnectorIdField>
export type InputStepSub0 = z.infer<typeof schemas.InputStepSub0>
export type InputSubstep2 = z.infer<typeof schemas.InputSubstep2>
export type Process3 = z.infer<typeof schemas.Process3>
export type GetWorkflowSummaryViewResponseData = z.infer<
  typeof schemas.GetWorkflowSummaryViewResponseData
>
export type RedactionBlock = z.infer<typeof schemas.RedactionBlock>
export type ProcessVerificationEnum = z.infer<typeof schemas.ProcessVerificationEnum>
export type StepNotification = z.infer<typeof schemas.StepNotification>
export type StepAssignmentCreate = z.infer<typeof schemas.StepAssignmentCreate>
export type CaseStatusAutomation = z.infer<typeof schemas.CaseStatusAutomation>
export type TagAutomation = z.infer<typeof schemas.TagAutomation>
export type TagAutomationAction = z.infer<typeof schemas.TagAutomationActionEnum>
export type TagAutomationTarget = z.infer<typeof schemas.TagAutomationTargetEnum>
export type CaseRoleAutomation = z.infer<typeof schemas.CaseRoleAutomation>
export type CommunicationAutomation = z.infer<typeof schemas.CommunicationAutomation>
export type CommunicationAutomationId = z.infer<typeof schemas.CommunicationAutomationIdField>
export type CommunicationAutomationRecipient = z.infer<
  typeof schemas.CommunicationAutomationRecipient
>
export type CommunicationRecipientType = z.infer<typeof schemas.ToEnum>
